import { Isometry }    from 'components/Isometry/Isometry'
import { useAtom } from 'jotai';
import { useParams }   from 'react-router-dom'
import {  toggle_drawer } from 'state/actions';
import { getFocus, useGet } from 'state/jotai';
import { _bootstrap } from 'state/store.bootstrap';
import { active_project, vis_desktop_nav, vis_detail, vis_filter } from 'state/store.global';

export const ViewIsometry = () => {
  const detailDrawer               = useAtom(vis_detail)[0];
  const toggle                     = useAtom(toggle_drawer)[1];
  const sub                        = useParams('sub').sub
  
  const pin         = useGet(active_project).pin
  const projectType = getFocus(_bootstrap, 'type');

  const [, setShowFilter] = useAtom(vis_filter);
  const [, setShowMenu]   = useAtom(vis_desktop_nav);

  return (
    <>
      <div style={{border:'0px solid gray',height: '100%', position:'relative'}} onClick={()=> {
        // detailDrawer && toggle("detail")
        setShowFilter(false);
        setShowMenu(false);
      }}>
         <Isometry/>
      </div>
    </>
  )
}